import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './shared/material.module';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { HeaderComponent } from './components/header/header.component';
import { TrailerComponent } from './components/trailer/trailer.component';
import { FooterComponent } from './components/footer/footer.component';

import { HomeComponent } from './pages/home/home.component';
import { MethodsComponent } from './pages/methods/methods.component';
import { ProjectsComponent } from './pages/projects/projects.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { ContactComponent } from './pages/contact/contact.component';

import { LinkComponent } from './components/link/link.component';
import { PageComponent } from './components/page/page.component';

import { StochasticModellingComponent } from './pages/methods/stochastic-modelling/stochastic-modelling.component';
import { PopulationModellingComponent } from './pages/methods/population-modelling/population-modelling.component';
import { SpatialModellingComponent } from './pages/methods/spatial-modelling/spatial-modelling.component';
import { BayesianInferenceComponent } from './pages/methods/bayesian-inference/bayesian-inference.component';
import { ReactionDiffusionSystemsComponent } from './pages/methods/reaction-diffusion-systems/reaction-diffusion-systems.component';
import { DataVisualisationComponent } from './pages/methods/data-visualisation/data-visualisation.component';

import { InflusimComponent } from './pages/projects/influsim/influsim.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { CardComponent } from './components/card/card.component';
import { MenschmikrobeComponent } from './pages/projects/menschmikrobe/menschmikrobe.component';
import { Schis2hivComponent } from './pages/projects/schis2hiv/schis2hiv.component';
import { QlaivsimComponent } from './pages/projects/qlaivsim/qlaivsim.component';
import { FourfluComponent } from './pages/projects/fourflu/fourflu.component';
import { SimsthComponent } from './pages/projects/simsth/simsth.component';
import { HantaComponent } from './pages/projects/hanta/hanta.component';
import { Inetfa2Component } from './pages/projects/inetfa2/inetfa2.component';
import { NmaComponent } from './pages/projects/nma/nma.component';
import { TommiComponent } from './pages/projects/tommi/tommi.component';
import { CovidsimComponent } from './pages/projects/covidsim/covidsim.component';
import { CovidcontrolComponent } from './pages/projects/covidcontrol/covidcontrol.component';
import { KsasimComponent } from './pages/projects/ksasim/ksasim.component';
import { ImaacComponent } from './pages/projects/imaac/imaac.component';
import { AggComponent } from './pages/projects/agg/agg.component';
import { IntersimComponent } from './pages/projects/intersim/intersim.component';
import { CtempComponent } from './pages/projects/ctemp/ctemp.component';
import { FourstrepComponent } from './pages/projects/fourstrep/fourstrep.component';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    TrailerComponent,
    FooterComponent,

    HomeComponent,
    MethodsComponent,
    ProjectsComponent,
    ProfileComponent,
    ContactComponent,

    LinkComponent,
    PageComponent,

    StochasticModellingComponent,
    PopulationModellingComponent,
    SpatialModellingComponent,
    BayesianInferenceComponent,
    ReactionDiffusionSystemsComponent,
    DataVisualisationComponent,
    InflusimComponent,
    NavbarComponent,
    CardComponent,
    MenschmikrobeComponent,
    Schis2hivComponent,
    QlaivsimComponent,
    FourfluComponent,
    SimsthComponent,
    HantaComponent,
    Inetfa2Component,
    NmaComponent,
    TommiComponent,
    CovidsimComponent,
    CovidcontrolComponent,
    KsasimComponent,
    ImaacComponent,
    AggComponent,
    IntersimComponent,
    CtempComponent,
    FourstrepComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
